
import React, { useContext, useEffect } from 'react'
import styles from "./style.module.css";
import QuestionBoard from '../../../components/Common/QuestionBoard/QuestionBoard'

import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Button from '../../../components/Common/Button';
import mainContext from '../../../context/mainContext';
import dataContext from '../../../context/dataContext';
import userRequests from '../../../components/api/userRequests';


// import Calc from '../Calc';

// TODO - end of assesment +++

export default function ComprehensionTest() {
    const [result, setResult] = useState([])
    const navigate = useNavigate();
    const location = useLocation();
    const data = location.state;

    const { header: { setPageName, setIsShowHeader }, loader: { loaderFetch, setLoaderFetch } } = useContext(mainContext)
    const { serverData, examData, setUserDetails, userDetails, setAssessmentId } = useContext(dataContext)

    useEffect(() => {
        setPageName("Comprehension")
        setIsShowHeader(true)
        return () => setPageName("")
    }, [])


    function Calc() {
        // server
        const numberOfLettersPerLine = examData.lines.map(line => line.words);
        //from api
        const timePerLine = [7000, 3000, 2000, 500, 1000, 3000];//TODO: is still mock data 
        numberOfLettersPerLine.pop();
        numberOfLettersPerLine.shift();
        let wpm = [];
        let sum = 0;

        for (let i = 0; i < timePerLine.length; i++) {
            wpm.push(numberOfLettersPerLine[i] / 5 / ((timePerLine[i] / 1000) * 60));
            sum += timePerLine[i];
        }

        console.log("wpm", wpm);
        let avg = sum / timePerLine.length;
        let std = 0;

        for (let i = 0; i < wpm.length; i++)
            std += (wpm[i] - avg) ** 2;

        std = std ** 0.5;
        console.log("avg:" + avg);
        console.log("std:" + std);
        return [wpm, std, avg]
    }



    const checkResults = async () => {
        const score = examData.questions.reduce((acc, currQuest) =>
            result.find(a => a.orderNum === currQuest.orderNum)?.answer === currQuest.answer ?
                ++acc :
                acc
            , 0)
        let { mean, std } = data.AvgNStd;
        const a = Calc()
        // console.log("🚀 ~ file: index.jsx:68 ~ checkResults ~ a:", a)
        let dataToSend = { testId: examData.id, testAnswer: result, result: { WPM: mean ? mean : 170, STD: std ? std : 15, CMP: score } }
        try {
            setLoaderFetch(true);
            let responseFromServer = await userRequests.addAssesmentRes(dataToSend, userDetails);//TODO: fix long load , maybe use the payload instead res, in case of good response ofcorse
            setUserDetails(responseFromServer);
            setAssessmentId("")//for user dosnt success to enter a new asess even with type rout
        } catch (error) {
            console.log("🚀 ~ file: ComprehensionTest.jsx:80 ~ checkResults ~ error:", error)
        } finally {
            setLoaderFetch(false);

        }
        navigate('/assessments/result', { state: { testAnswer: result, count: score, WPM: mean ? mean : 170, STD: std ? std : 15, AVG: mean ? mean : 170, from: "assessments" } })
    }


    const saveAnswer = (orderNum, answerBool, id) => {
        // console.log("🚀 ~ file: index.jsx:76 ~ saveAnswer ~ result:", result)
        const temp = JSON.parse(JSON.stringify(result));
        const found = temp.find(a => a.orderNum === orderNum)
        found ? found.answer = answerBool : temp.push({ orderNum, answer: answerBool, questionId: id })
        setResult(temp)
    }

    return (
        <div className={styles.container} style={window.buildType === "iPhone" ? { height: "85dvh", overflowY: "scroll" } : {}}>
            <div className={styles.questions}>
                {examData.questions.map((question, i) =>
                    <QuestionBoard
                        index={i}
                        saveAnswer={saveAnswer}
                        question={question}
                        key={question._id}
                        result={result}
                    />
                )}
            </div>
            <div className={styles.submitDiv}>
                <Button disabled={result.length !== 10} startFunction={checkResults} title={result.length == 10 ? 'NEXT' : `${result.length}/10 to go`} />
            </div>
        </div>
    )
}
